import clsx from "clsx";

function getHourTitleFromPayload(payload) {
  let hour = payload[0]
    ? payload[0].payload["hour"]
    : payload[1]
    ? payload[1].payload["hour"]
    : "";

  return hour + ` - ${hour.split(":")[0] + ":59"}`;
}

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    // let currentDay = payload[0].payload.day.split("/");
    // console.log(payload);
    return (
      <div className="bg-white shadow-xl p-4 text-sm border rounded-md space-y-1 animate-fadeIn">
        <p className="font-bold">
          {/* {new Date(currentDay[1] + "/" + currentDay[0] + "/" + new Date().getUTCFullYear()).toDateString()} */}
          {/* {label + ":00 - " + label + ":59"} */}
          {getHourTitleFromPayload(payload)}
        </p>
        {payload[1] && (
          <p
            className={clsx({
              "text-blue-500 opacity-80 ": payload[1].dataKey === "westToEast",
            })}
          >{`West To East: ${payload[1].value.toLocaleString()}`}</p>
        )}
        {payload[0] && (
          <p
            className={clsx(
              { "text-gray-700": payload[0].dataKey === "Leaving" },
              { "text-blue-500": payload[0].dataKey === "Entering" },
              {
                "text-green-500 opacity-80":
                  payload[0].dataKey === "eastToWest",
              }
            )}
          >{`East To West : ${payload[0].value.toLocaleString()}`}</p>
        )}
        {payload[2] && (
          <p
            className={clsx({
              " text-red-500 opacity-80 ": payload[2].dataKey === "eastToNorth",
            })}
          >{`East To North : ${payload[2].value.toLocaleString()}`}</p>
        )}
        {payload[3] && (
          <p
            className={clsx({
              " text-yellow-500 opacity-80 ":
                payload[3].dataKey === "northToEast",
            })}
          >{`North To East : ${payload[3].value.toLocaleString()}`}</p>
        )}
      </div>
    );
  }

  return null;
};

export default CustomTooltip;
